import React from 'react';
import { useForm } from 'react-hook-form';
import { SectionCard } from '@/components/common/SectionCard';
import { callApi, ThrowError } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import { showToastNotification } from '@/utility/helper';
import FormField from '@/components/common/FormField';
import Button from '@/components/common/Button';
import { errorTypes } from '@/utility/validation';

interface ISecurityForm {
    currentPassword: string;
    password: string;
    confirmPassword: string;
}

export const SecurityTab = () => {
    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors, isSubmitting },
    } = useForm<ISecurityForm>();

    const onSubmit = async (data: ISecurityForm) => {
        try {
            await callApi(
                `${API_URL}${API_ENDPOINT.user}/update-profile`,
                {
                    method: 'PUT',
                    data: {
                        currentPassword: data.currentPassword,
                        password: data.password,
                    }
                }
            );

            showToastNotification('success', 'Password updated successfully');
            reset();
        } catch (error) {
            ThrowError(error);
        }
    };

    const password = watch('password');

    return (
        <div className="">
            <SectionCard title="Change Password">
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                    <FormField
                        type="password"
                        label="Old Password"
                        placeholder="Enter old password"
                        error={errors.currentPassword?.message}
                        {...register('currentPassword', {
                            ...errorTypes.required('Old Password')
                        })}
                    />

                    <FormField
                        type="password"
                        label="New Password"
                        placeholder="Enter new password"
                        error={errors.password?.message}
                        {...register('password', {
                            ...errorTypes.required('New Password'),
                            ...errorTypes.password
                        })}
                    />

                    <FormField
                        type="password"
                        label="Confirm New Password"
                        placeholder="Confirm your new password"
                        error={errors.confirmPassword?.message}
                        {...register('confirmPassword', {
                            ...errorTypes.required('Confirm Password'),
                            validate: (value) => value === password || 'Passwords do not match'
                        })}
                    />

                    <div className="flex justify-end pt-4">
                        <Button
                            type="submit"
                            isLoading={isSubmitting}
                            loadingText="Updating..."
                        >
                            Update Password
                        </Button>
                    </div>
                </form>
            </SectionCard>
        </div>
    );
};

export default SecurityTab;
